export default __webpack_public_path__ + "static/media/plus.6c3a402d.svg";